
<v-hover v-slot="{ hover }" open-delay="200">
    <v-flex xs12>
        <v-card
            flat
            rounded
            active-class = "pa-0"
            :class       = "!message.incidentId?'inb-attached':'inb-detached '"
            class        = "message-card lm-border"
        >
            <div class="pa-3">
                <inb-message-entry-menu
                    v-show   = "hover"
                    v-model  = "menuOpen"
                    :message = "message"
                    @edit    = "onEdit"
                />

                 <div class="w-100">
                     <!-- Headerline -->
                     <div class="inb-headline" >
                         <div class="primary--text v-flex" style="width: calc(100% - 120px)">
                             <div class="inb-status" :class="statuscolor"></div>
                             <div v-if="message.type.id===type.assessment" class="inb-title">
                                 {{ message.origin.name }} {{ $t("inb.menu.assessment.type", [message.assessmenttype , assessmentAsString ]) }}
                             </div>

                             <div v-if="message.type.id===type.invoice && message.invoiceType"  class="w-100">
                                 <span v-if="message.origin.id!==1">{{ message.origin.name }} </span>{{ message.type.name }} - {{ message.invoiceType.name }}
                             </div>

                             <div v-if="message.type.id!==type.assessment && !message.invoiceType" class="w-100">
                                 <span v-if="message.origin.id!==1">{{ message.origin.name }} </span>{{ message.type.name }}
                             </div>
                         </div>
                         <div style="width: 150px; text-align: right">
                             {{ timeAsString }}
                         </div>
                     </div>
                     <!-- Headerline -->

                     <!-- Sites  -->
                     <div v-if="message.sites && message.sites.length > 0" >
                         <div class="v-flex space-between">
                             <div class="inb-fabricno w-100" >
                                 <a v-if="linkAllowed" @click="onSite(message.sites[0].id)" class="black--text">
                                     {{ message.sites[0].fabricNo }}
                                     <i class="fas fa-caret-right"></i>
                                 </a>
                                 <div v-if="!linkAllowed">
                                     {{ message.sites[0].fabricNo }}
                                 </div>
                             </div>
                             <div v-if="message.sites.length > 1" class="v-flex">
                                 <c-site-icon-list
                                     color     = "primary"
                                     size      = "15"
                                     :sites    = "message.sites"
                                     :incident-id = "message.incidentId"
                                     @selected = "onSites"
                                 />
                             </div>
                         </div>
                         <div class="inb-sites">
                             {{ message.sites[0].location }}
                         </div>

                         <v-expand-transition>
                             <div v-if="expand" class="mt-1 mb-1">
                                 <div v-for="(site, index) in sitelist" :key="index" class="">
                                     <v-divider class="mt-1 mb-1" />
                                     <div class="v-flex" style="justify-content: space-between">
                                         <div>{{ site.fabricNo }}</div>
                                     </div>
                                     <div class="card-subtitle">{{ site.street }}, {{ site.zip }} {{ site.city }}</div>
                                 </div>
                                 <v-divider class="mt-1 mb-1" />
                             </div>
                         </v-expand-transition>

                     </div>

                     <div v-if="message.sites.length === 0" >
                         <div class="inb-sites">
                             {{ $t("inb.menu.site.notfound") }}
                         </div>
                     </div>
                     <!-- Sites  -->

                     <!-- Subject -->
                     <div class="w-100">
                         <div
                             class="inb-message-subject"
                             v-if="message.type.id===type.assessment"
                         >
                             {{ message.result }}
                         </div>
                         <v-tooltip left max-width="400" v-if="message.type.id!==type.assessment">
                             <template v-slot:activator="{ on, attrs }">
                                <div
                                    v-bind="attrs"
                                    v-on="on"
                                    class="inb-message-subject"
                                >
                                    {{ message.subject }}
                                </div>
                             </template>

                             <div >
                                {{ message.subject }}
                             </div>
                         </v-tooltip>
                     </div>
                     <!-- Subject -->

                     <div class="v-flex">
                         <div class="mt-1 lm-border w-50 v-flex" style="  border-radius: 0;" >
                             <div>
                                 <v-icon class="ml-1" style="font-size: 20px">{{ icon }}</v-icon>
                             </div>
                             <div class="inb-filename">
                                {{ message.filename }}
                            </div>
                         </div>
                         <div class="w-50" style="text-align: right; padding-top: 3px;" v-if="message.customer">
                             {{ message.customer.name }}
                         </div>
                     </div>
                 </div>
            </div>
        </v-card>
    </v-flex>
</v-hover>
